export default __webpack_public_path__ + "static/onsite-bed36635596eb76fac0f4b571d888ed1.webp";